import { render, staticRenderFns } from "./OrderFiltersForm.vue?vue&type=template&id=291a1aca&"
import script from "./OrderFiltersForm.vue?vue&type=script&lang=ts&"
export * from "./OrderFiltersForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports